var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 11.4591L11.4001 5.1001L11.4001 8.7001C2.99988 10.5001 2.99988 18.9001 2.99988 18.9001C2.99988 18.9001 6.59988 14.1001 11.4001 14.7001L11.4001 18.4201L21.0001 11.4591Z",
    stroke: "#4169E1",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.799bc03f10bc5c5da46e7d81475b7e9d.svg";
export { ForwardRef as ReactComponent };